import React from 'react';
import './Movableplaten.css';
import movableImg from '../../../imgs/Movablep.webp';

const Movableplaten = () => {
  return (
    <div className="movable-container">
      <div className="movable-text"data-aos="fade-down-left">
        <h1>Movable Platen Clamping System</h1>
        <p>
          Our system uses four independent clamping cylinders in a modular design.
          This ensures an even force distribution, extending the life of the tie-bars
          and guaranteeing the best product quality.
        </p>
        <p>
          Thanks to our integrated design, maintenance is quick and efficient,
          leading to shorter downtimes.
        </p>
      </div>

      <div className="movable-image"data-aos="fade-down-right">
        <img src={movableImg} alt="Movable Platen Clamping System" />
      </div>
    </div>
  );
};

export default Movableplaten;
